<template>
  <a-button type="primary" @click="insertOXml" :loading="isInserting">
    insert content
  </a-button>
</template>
<script>
import OXmlContent from "./templateXml.js";
export default {
  data() {
    return {
      isInserting: false
    };
  },
  methods: {
    insertOXml() {
      // Xem thêm
      // https://docs.microsoft.com/en-us/javascript/api/word/word.body?view=word-js-1.3.

      this.isInserting = true;

      Word.run(context => {
        // Create a proxy object for the document body.
        const body = context.document.body;

        body.insertOoxml(OXmlContent, Word.InsertLocation.replace);

        // Synchronize the document state by executing the queued commands,
        // and return a promise to indicate task completion.
        return context.sync().then(() => {
          console.log("XML added to the beginning of the document body.");
          this.isInserting = false;
        });
      }).catch(error => {
        console.log("Error: " + JSON.stringify(error));
        this.isInserting = false;
        if (error instanceof OfficeExtension.Error) {
          console.log("Debug info: " + JSON.stringify(error.debugInfo));
        }
      });
    }
  }
};
</script>
